import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string | undefined;
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}

const Confirm: FC<Props> = ({ text, open, onOk, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => onCancel()}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: 500,
          maxHeight: '60%',
          margin: 0,
          borderRadius: 0,
        },
        '& .MuiDialog-paperScrollPaper': {
          maxHeight: '100%',
        },
        '& .MuiInputBase-input': {
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle>{text}</DialogTitle>
      <DialogActions>
        <Button onClick={() => onOk()}>{t('yes')}</Button>
        <Button onClick={() => onCancel()}>{t('no')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default Confirm;
